import React from "react";
import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import styles from "./Detail.module.scss";

export interface DetailProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
  children: React.ReactNode;
}

const DefaultDetail = (props: DetailProps) => {
  const { as: Component = "span", className, children, ...otherProps } = props;
  return (
    <Component className={clsx(styles.detail, className)} data-deci-detail="true" {...otherProps}>
      {children}
    </Component>
  );
};

const Detail = createPluggable<DetailProps>("deci.detail", DefaultDetail);

export interface DetailIconProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
  children: React.ReactNode;
}

const DefaultDetailIcon = (props: DetailIconProps) => {
  const { as: Component = "span", className, children, ...otherProps } = props;
  return (
    <Component className={clsx(styles.icon, className)} data-deci-detail-icon="true" {...otherProps}>
      {children}
    </Component>
  );
};

const DetailIcon = createPluggable<DetailIconProps>("deci.detail.icon", DefaultDetailIcon);

export interface DetailTitleProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
  children: React.ReactNode;
}

const DefaultDetailTitle = (props: DetailTitleProps) => {
  const { as: Component = "span", className, children, ...otherProps } = props;
  return (
    <Component className={clsx(styles.title, className)} data-deci-detail-title="true" {...otherProps}>
      {children}
    </Component>
  );
};

const DetailTitle = createPluggable<DetailTitleProps>("deci.detail.title", DefaultDetailTitle);

export interface DetailContentProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
  children: React.ReactNode;
}

const DefaultDetailContent = (props: DetailContentProps) => {
  const { as: Component = "span", className, children, ...otherProps } = props;
  return (
    <Component className={clsx(styles.content, className)} data-deci-detail-content="true" {...otherProps}>
      {children}
    </Component>
  );
};

const DetailContent = createPluggable<DetailContentProps>("deci.detail.content", DefaultDetailContent);

export default Object.assign(Detail, {
  Icon: DetailIcon,
  Title: DetailTitle,
  Content: DetailContent,
});
